enum PreQualificationLetterCountry {
  NORWAY = 'NORWAY',
  NON_NORWAY = 'NON-NORWAY',
}

export default PreQualificationLetterCountry;
